var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummaryBatteryNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0163 61.7981H7.98366C4.22996 61.7981 1.18652 58.7163 1.18652 54.9147V8.0858C1.18652 4.28374 4.22996 1.2019 7.98366 1.2019H55.0163C58.77 1.2019 61.813 4.28374 61.813 8.0858V54.9147C61.813 58.7163 58.77 61.7981 55.0163 61.7981Z",
    stroke: "#D8D8D8",
    strokeWidth: 2.385
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7834 15.4678V16.9237H24.1268C23.3978 16.9237 22.8066 17.579 22.8066 18.3877V47.1887C22.8066 47.9969 23.3978 48.6523 24.1268 48.6523H38.9052C39.6342 48.6523 40.2254 47.9969 40.2254 47.1887V18.3877C40.2254 17.579 39.6342 16.9237 38.9052 16.9237H35.2486V15.4678C35.2486 14.6573 34.7681 14.0001 34.1752 14.0001H28.8563C28.2639 14.0001 27.7834 14.6573 27.7834 15.4678Z",
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_826_326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 63H63V0H0V63Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_826_326)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0786 46.4742H37.9532V19.1019H25.0786V46.4742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5947 44.3049H36.4805V39.5849H26.5947V44.3049Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5947 39.1082H36.4805V34.3882H26.5947V39.1082Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5947 33.9591H36.4805V29.2391H26.5947V33.9591Z",
    fill: "#D8D8D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBatteryNo);
export default __webpack_public_path__ + "static/media/summary_battery_no.e7314d7c7422677a01936855b1a95c68.svg";
export { ForwardRef as ReactComponent };